import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  image: {
    borderRadius: '20px',
    boxShadow: '0.5em 0.5em 1em',
    objectFit: 'cover',
    maxWidth: '90%',
  },
}));
